export default function isShippingStateAvailable(countryCode) {
	return ['US', 'CA'].includes(countryCode);
}
